import React, { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'

import useIdentities from '../../../hooks/api/useIdentities'
import BarChart from './BarChart'
import PieCharts from './PieCharts'

const Graphs = ({ activities, activityTypes }) => {
  const [tab, setTab] = useState(0)

  const { identities, isLoading, hasLoadError } = useIdentities()

  if (isLoading || hasLoadError || !activityTypes) return null

  return (
    <>
      <Tabs
        onChange={(_, val) => setTab(val)}
        value={tab}
        centered
        sx={{ mb: 1 }}
      >
        <Tab label={'Bar chart'}></Tab>
        <Tab label={'Pie charts'}></Tab>
      </Tabs>
      {tab === 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BarChart
            activities={activities}
            activityTypes={activityTypes}
            identities={identities}
          />
        </Box>
      )}
      {tab === 1 && (
        <PieCharts
          activities={activities}
          activityTypes={activityTypes}
          identities={identities}
        />
      )}
    </>
  )
}

export default Graphs
